import { BlogPostType } from "./../types/BlogPostType";
import axios from "axios";

import { updateBlogPostIsPublished } from "../apiConsts";

export async function updateIsPublished(
  blogPostId: string,
  isPublished: boolean
): Promise<boolean> {
  try {
    const response = await axios.post(updateBlogPostIsPublished, {
      postId: blogPostId,
      isPublished: isPublished,
    });
    return response.status === 200;
  } catch (error) {
    return false;
  }
}
